import { ElementTypes } from '../element-types';
import { kebabCase } from 'lodash-es';
import { E2e } from './e2e.constant';

export class Qqc {
  static readonly prefix: string = 'qqc';
  static readonly GetQuote: string = `${Qqc.prefix}-${ElementTypes.Button}-get-quote`;
  static readonly CancelQuote: string = `${Qqc.prefix}-${ElementTypes.Button}-cancel-quote`;
  static readonly SingleTripSelector: string = `${Qqc.prefix}-${ElementTypes.RadioButton}-single-trip`;
  static readonly AnnualMultipleTripSelector: string = `${Qqc.prefix}-${ElementTypes.RadioButton}-annual-multiple-trip`;
  static readonly OneTraveller: string = `${Qqc.prefix}-${ElementTypes.RadioButton}-1-travellers`;
  static readonly TwoTravellers: string = `${Qqc.prefix}-${ElementTypes.RadioButton}-2-travellers`;
  static readonly FamilyTravellers: string = `${Qqc.prefix}-${ElementTypes.RadioButton}-family-travellers`;
  static readonly DestinationCountry: string = `${Qqc.prefix}-${ElementTypes.Autocomplete}-country`;
  static readonly DestinationRegion: string = `${Qqc.prefix}-${ElementTypes.Dropdown}-region`;
  static readonly PmiOption: string = `${Qqc.prefix}-${ElementTypes.Checkbox}-pmi-option`;
  static readonly TravelDate: string = `${Qqc.prefix}-${ElementTypes.DatePicker}-travel-date`;
  static readonly Form: string = `${Qqc.prefix}-${ElementTypes.Form}`;

  static TravellerType(travellerNumber: number): string {
    if (travellerNumber == 1) {
      return this.OneTraveller;
    } else if (travellerNumber == 2) {
      return this.TwoTravellers;
    } else {
      return this.FamilyTravellers;
    }
  }

  static TripType(type: E2e.TripType): string {
    return `${Qqc.prefix}-${ElementTypes.RadioButton}-${kebabCase(type)}`;
  }

  static TravellerAge(index: number): string {
    return `${Qqc.prefix}-${ElementTypes.Input}-traveller-age-${index}`;
  }
}
